import React, { useEffect, useState } from 'react';


const BiLabel = (props) => {

    return (
        <label style={props.style} >
            {props.icon &&
                <i style={{ marginRight: "5px",width:"20px", color:"gray" }} className={props.icon}></i>
            }
            {props.children}
        </label>
    );
}

export default BiLabel;

